import * as Actions from '../actions';

const initialState = {
    window_dimension : {
        height: window.innerHeight,
        width: window.innerWidth
    },
    hasil_simpan_feedback: {success: false},
    loading: 'none',
    loading_besar: false,
    jenis_badge:{},
    toggle_badge:{
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false
    },
    display_toolbar: 'flex',
    judul: 'Beranda',
    kepsek_isi_kuesioner: true,
    dialog_sekolah_binaan: false,
    hasil_notifikasi: [],
    notifikasi: {
        rows: [],
        total: 0
    },
    notifikasi_kecil: {
        rows: [],
        total: 0
    },
    hasil_notifikasi_baca: {
        rows: [],
        total: 0
    },
    kepala_sekolah: {
        rows:[{
            nama_kepsek: 'KEPSEK'
        }],
        total: 0
    },
    hasil_login: {
        token: null,
        user: [],
        user_ganda: [],
        jumlah: 0
    },
    backup: {},
    log_backup: {
        total: 0,
        rows: []
    },
    log_restore: {
        total: 0,
        rows: []
    },
    restore: {}
};

const appReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.UPDATE_WINDOW_DIMENSION:
        {
            return {
                ...state,
                window_dimension: action.window_dimension
            };
        }
        case Actions.SET_LOADING:
        {
            return {
                ...state,
                loading: action.loading
            };
        }
        case Actions.SET_LOADING_BESAR:
        {
            return {
                ...state,
                loading_besar: action.loading_besar
            };
        }
        case Actions.SET_DIALOG_SEKOLAH_BINAAN:
        {
            return {
                ...state,
                dialog_sekolah_binaan: action.dialog_sekolah_binaan
            };
        }
        case Actions.SET_FEEDBACK:
        {
            return {
                ...state,
                hasil_simpan_feedback: action.hasil_simpan_feedback
            };
        }
        case Actions.SET_HASIL_FEEDBACK:
        {
            return {
                ...state,
                hasil_simpan_feedback: action.hasil_simpan_feedback
            };
        }
        case Actions.GET_JENIS_BADGE:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                jenis_badge: action.payload
            };
        }
        case Actions.TOGGLE_BADGE_OPEN:
        {
            console.log(action.toggle_badge);
            return {
                ...state,
                toggle_badge: action.toggle_badge
            };
        }
        case Actions.GET_DISPLAY_TOOLBAR:
        {
            return {
                ...state,
                display_toolbar: action.display_toolbar
            };
        }
        case Actions.SET_DISPLAY_TOOLBAR:
        {
            return {
                ...state,
                display_toolbar: action.display_toolbar
            };
        }
        case Actions.GET_JUDUL:
        {
            return {
                ...state,
                judul: action.judul
            };
        }
        case Actions.SET_JUDUL:
        {
            return {
                ...state,
                judul: action.judul
            };
        }
        case Actions.SET_KEPSEK_ISI_KUESIONER:
        {
            return {
                ...state,
                kepsek_isi_kuesioner: action.kepsek_isi_kuesioner
            };
        }
        case Actions.GET_NOTIFIKASI:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                notifikasi: action.payload
            };
        }
        case Actions.GET_NOTIFIKASI_KECIL:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                notifikasi_kecil: action.payload
            };
        }
        case Actions.SET_NOTIFIKASI_BACA:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_notifikasi_baca: action.payload
            };
        }
        case Actions.GET_KEPALA_SEKOLAH:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                kepala_sekolah: action.payload
            };
        }
        case Actions.LOGIN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_login: action.payload
            };
        }
        case Actions.BACKUP:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                backup: action.payload
            };
        }
        case Actions.GET_LOG_BACKUP:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                log_backup: action.payload
            };
        }
        case Actions.GET_LOG_RESTORE:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                log_restore: action.payload
            };
        }
        case Actions.RESTORE:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                restore: action.payload
            };
        }
        default:
        {
            return state;
        }
    }
}

export default appReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/App.reducers.js